var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostCardBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17472",
    transform: "translate(8 8)",
    fill: "#185edf",
    stroke: "#707070",
    d: "M0 0h34v34H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1476",
    transform: "translate(-8 -8)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17473",
    fill: "none",
    d: "M8 8h34v34H8z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37400",
    fill: "#185edf"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21689",
    d: "M39.167 13.667H10.833a1.417 1.417 0 0 0-1.416 1.416V25a1.417 1.417 0 0 0 1.629 1.417 1.487 1.487 0 0 0 1.2-1.487V16.5h25.5v17h-7.079a1.417 1.417 0 0 0-1.417 1.629 1.487 1.487 0 0 0 1.487 1.2h8.429a1.417 1.417 0 0 0 1.417-1.417V15.083a1.417 1.417 0 0 0-1.416-1.416Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21690",
    d: "M9.417 30.667v4.25a1.487 1.487 0 0 0 1.558 1.417h13.883a1.487 1.487 0 0 0 1.558-1.417v-4.25a14.521 14.521 0 0 0-8.5-2.833 14.521 14.521 0 0 0-8.5 2.833ZM23.583 33.5H12.25v-1.275a11.05 11.05 0 0 1 11.333 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21691",
    d: "M27.833 22.167h7.083a1.417 1.417 0 0 0 0-2.833h-7.083a1.417 1.417 0 0 0 0 2.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21692",
    d: "M36.333 26.417A1.417 1.417 0 0 0 34.917 25h-7.084a1.417 1.417 0 1 0 0 2.833h7.083a1.417 1.417 0 0 0 1.417-1.416Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21693",
    d: "M22.167 22.167a4.25 4.25 0 1 0-4.25 4.25 4.25 4.25 0 0 0 4.25-4.25Zm-5.667 0a1.417 1.417 0 1 1 1.417 1.417 1.417 1.417 0 0 1-1.417-1.417Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostCardBlue);
export default __webpack_public_path__ + "static/media/Post_card_blue.95343b54b932d084b52c78a16d345f08.svg";
export { ForwardRef as ReactComponent };